import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
    apiKeys: [],
    twilioChannelInfo: {},
    incomingEventChannelInfo: {},
    podiumChannelInfo: {},

    getApiKeysLoading: false,
    deleteApiKeyLoading: false,
    generateApiKeyLoading: false,
    twilioChannelInfoLoading: false,
    updateTwilioChannelInfoLoading: false,

    incomingEventChannelInfoLoading: false,
    updateIncomingEventChannelInfoLoading: false,

    podiumChannelInfoLoading: false,
    updatePodiumChannelInfoLoading: false,
});

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters,
};
